import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MoreService } from '@app/more/services/more.service';
import { ModalController, Platform } from '@ionic/angular';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { AppService } from '@shared/services/app.service';
import { LoadingSpinnerService } from '@shared/services/loading-spinner/loading-spinner.service';
import { QRCode } from '@usf/alert-types';
import { Customer } from '@usf/customer-types';
import { QR_CODE_ACTIONS } from '@usf/ngrx-alerts';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chef-store-qr-code',
  templateUrl: './chef-store-qr-code.component.html',
  styleUrls: ['./chef-store-qr-code.component.scss'],
})
export class ChefStoreQrCodeComponent implements OnInit, OnDestroy {
  @Input() customer: Customer;
  @Input() userId: string;
  @Input() userName: string;
  resumeSub$: Subscription;
  successSub$: Subscription;
  generateQRCodeTimeout: ReturnType<typeof setTimeout>;
  qrCode: string;
  refreshInterval: any;
  interval = 15;
  qrCodeWidth =
    window.innerWidth < 361 || window.innerHeight < 668
      ? window.innerHeight < 321
        ? 130
        : 180
      : 260;

  constructor(
    private modalController: ModalController,
    private platform: Platform,
    private moreService: MoreService,
    private actionSubject: ActionsSubject,
    private loadingSpinnerService: LoadingSpinnerService,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.generateQRCode();
    this.refreshInterval = setInterval(() => {
      this.generateQRCode();
    }, this.interval * 60 * 1000);
    this.resumeSub$ = this.platform.resume.subscribe(() => {
      this.generateQRCode();
    });
    this.successSub$ = this.actionSubject
      ?.pipe(ofType(QR_CODE_ACTIONS.trackQRCodeSuccess))
      ?.subscribe(async data => {
        clearTimeout(this.generateQRCodeTimeout);
        await this.loadingSpinnerService.dismissSpinnerModal();
        this.qrCode = data?.response?.signedData?.toString();
      });
  }

  ngOnDestroy() {
    clearInterval(this.refreshInterval);
    this.qrCode = null;
    if (this.resumeSub$) {
      this.resumeSub$.unsubscribe();
    }
    if (this.successSub$) {
      this.successSub$.unsubscribe();
    }
  }

  async generateQRCode() {
    if (this.customer) {
      await this.loadingSpinnerService.createSpinnerModal();
      this.qrCode = null;
      const customerNumber = this.customer.customerNumber
        .toString()
        .padStart(8, '0');
      const divisionNumber = this.customer.divisionNumber
        .toString()
        .padStart(4, '0');
      const now = new Date();
      const timestamp =
        (now.getMonth() + 1).toString().padStart(2, '0') +
        now.getDate().toString().padStart(2, '0') +
        now.getFullYear() +
        now.getHours().toString().padStart(2, '0') +
        now.getMinutes().toString().padStart(2, '0') +
        now.getSeconds().toString().padStart(2, '0');
      const qrCodeString = customerNumber + divisionNumber + timestamp;
      const qrCodeObj: QRCode = {
        addDtm: now,
        userId: this.userId,
        username: this.userName,
        customerNumber: +customerNumber,
        divisionNumber: +divisionNumber,
      };
      this.moreService.trackQRCode(qrCodeString, qrCodeObj);
      this.generateQRCodeTimeout = setTimeout(async () => {
        await this.loadingSpinnerService.dismissSpinnerModal();
        this.cancel();
      }, 5000);
    }
  }

  cancel() {
    this.modalController.dismiss();
  }

  routeTo(path: string) {
    this.appService.openUrlInBrowser(path);
  }
}
